import { IdentityDocumentType, PhoneNumberType } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
import { isoDateString } from '../_shared/dates.js';
export const createPhoneNumberSchema = z.object({
    number: z.string().min(1),
    type: z.nativeEnum(PhoneNumberType),
});
export const updatePhoneNumberSchema = z.object({
    number: z.string().min(1).optional(),
    type: z.nativeEnum(PhoneNumberType).optional(),
});
export const createFidelityCardSchema = z.object({
    companyId: z.string().min(1),
    cardNumber: z.string().min(1),
});
export const createIdentityDocumentSchema = z.object({
    documentNumber: z.string().min(1),
    expiryDate: isoDateString(),
    issuingCountry: z.string().length(3),
    type: z.nativeEnum(IdentityDocumentType),
});
